import { Inject, Injectable, OnDestroy, Optional, PLATFORM_ID, isDevMode } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { LocalStorageService } from './local-storage.service';
import { EventManager } from '@angular/platform-browser';
import { XHttpService } from '@app/core/services/x-http.service';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { TgBot } from '../models/models';
import { Helper } from '../helper';
import { WebAppService } from './web-app.service';

@Injectable({
    providedIn: 'root',
})
export class StateService implements OnDestroy {
    stateMatch!: {
        [key: number]: {
            [key: number]: {
                n: string;
                s: string;
            };
        };
    };
    prevUrl!: string;
    prevParams!: any;
    lang$!: BehaviorSubject<{ code: string }>;
    //timeZone
    tZ$!: BehaviorSubject<{ offset: number }>;
    //изменение времени
    rs$: BehaviorSubject<{ clientWidth: number }> = new BehaviorSubject({
        clientWidth: this.doc.documentElement.clientWidth,
    });
    readonly browserTimeZone: number = -(new Date().getTimezoneOffset() / 60);
    dir!: string;
    d$: Subject<boolean> = new Subject();
    botState!: {
        queryParams: {
            b: string,
            c: string,
            t: string,
        } | {
            i: string,
        },

    }
    routerCounter!: number
    prevTheme!: string
    constructor(
        @Inject(DOCUMENT)
        private doc: Document,
        private lS: LocalStorageService,
        private http: XHttpService,
        private ar: ActivatedRoute,
        @Inject(PLATFORM_ID)
        private plId: Object,
        private em: EventManager,
        private r: Router,
        @Inject('TGBOT')
        private bot: TgBot,
        private was: WebAppService,
    ) {
        this.routerCounter = 1
        this.bot.WebApp.BackButton.onClick(() => {
            history.back()
        });
        r.events
            .subscribe((event: any) => {
                if (event instanceof NavigationStart) {
                    if (event.navigationTrigger === 'popstate') {
                        this.routerCounter--;
                    } else {
                        this.routerCounter++;
                    }
                    if (this.routerCounter === 2) {
                        this.bot.WebApp.BackButton.show();
                    }

                    if (this.routerCounter === 1) {
                        this.bot.WebApp.BackButton.hide();
                    }

                }
            });

        this.bot.WebApp.onEvent('themeChanged', () => {
            this.themeChanged() });
        !Helper.isMobile() ? this.doc.body.classList.add('pc') : null;
        this.themeChanged()
        //  для арабских ('rtl'), остальных ('ltr')
        this.dir = this.doc.documentElement.dir;
        // язык сайта
        const lang = this.doc.documentElement.lang;
        this.lang$ = new BehaviorSubject({ code: lang === 'cs' ? 'cz' : lang });

        //часовой пояс пользователя
        let z: any = Number(this.lS.getItem('timeZone'));
        !z ? (z = -(new Date().getTimezoneOffset() / 60)) : null;
        this.tZ$ = new BehaviorSubject({ offset: +z! });

        //RESIZE
        if (isPlatformBrowser(this.plId)) {
            this.em.addEventListener(this.doc.documentElement, 'resize', (e: any) => {
                this.rs$.value.clientWidth != e.target.innerWidth
                    ? this.rs$.next({ clientWidth: e.target.innerWidth })
                    : null;
            });
        }

        //состояние матча лайв
        this.http.get('/v3/' + this.language.code + '/states.json').subscribe(
            (res) => {
                this.stateMatch = res;
            },
            (err) => {
                console.log(err);
            }
        );
        //bot init

        if (isPlatformBrowser(this.plId) && !isDevMode() && !this.bot.WebApp.initData) {
            globalThis.stop();
        }

        const qp = this.ar.snapshot.queryParams;
        if (qp['b'] && qp['c'] && qp['t']) {
            this.botState = {
                queryParams: {
                    b: this.ar.snapshot.queryParams['b'],
                    c: this.ar.snapshot.queryParams['c'],
                    t: this.ar.snapshot.queryParams['t']
                }
            }
        } else if (this.was.initData) {
            console.log(this.was.initData);
            this.botState = {
                queryParams: {
                    i: this.was.initData
                }
            }
        } else {
            this.botState = {
                queryParams: {
                    i: ''
                }
            };
            return;
        }

        this.http.post('/v3.2/sec', {}, {params: this.http.httpParams(this.botState.queryParams)}).subscribe(() => {});
    }
    ngOnDestroy(): void {
        this.bot.WebApp.BackButton.hide();
        this.bot.WebApp.BackButton.offClick(() => { });
    }

    get language(): { code: string } {
        return this.lang$.value;
    }

    set timeZone(val: { offset: number }) {
        let curr = val.offset;
        this.lS.setItem('timeZone', curr);
        this.tZ$.next({ offset: curr });
    }

    get timeZone(): { offset: number } {
        return this.tZ$.value;
    }

    getPeriod(id: number, status: number) {
        return this.stateMatch &&
            this.stateMatch[id] &&
            this.stateMatch[id][status]
            ? this.stateMatch[id][status]
            : null;
    }

    themeChanged() {
        var theme = this.bot.WebApp.colorScheme
        if (this.prevTheme) {
            this.doc.body.classList.remove('theme-' + this.prevTheme);
        }
        if (theme && theme !== 'light') {
            this.prevTheme = theme;
            this.doc.body.classList.add('theme-' + theme);
        }
    }
    isPretty() {
        let par = this.ar.snapshot.queryParams;
        if (par['pretty'] && par['pretty'] == 1) {
            this.lS.setItem('pretty', Date.now() + 3.6e+6);
            return true;
        } else if (this.lS.getItem('pretty')) {
            if (Date.now() - this.lS.getItem('pretty') > 0) {
                this.lS.removeItem('pretty');
                return false;
            } else {
                return true;
            }
        } else {
            return false;
        }
    }
}

